<template>
  <div class="amount-badge">
    <span 
      class="amount font-weight-bold" 
      :class="{'text-green': type == 'DEPOT', 'text-red': type == 'RETRAIT'}">
      {{ formattedAmount }}
    </span>
  </div>
</template>

<script>
import { DEPOT, RETRAIT } from "@/constants/payments";
export default {
  name: "AmountBadge",
  props: {
      type:{
        type:String,
        required:false,
        default: DEPOT
      },
    amount: {
      type: [Number,String],
      required: true
    },
    symbol: {
      type: String,
      default: '$'
    },
  },
  computed: {
    isOut() {
      if(this.type==RETRAIT){
        return true;
      }
      return this.amount < 0;
    },
    formattedAmount() {
      const decimalPlaces = (this.amount.toString().split('.')[1] || "").length;
      let sign = this.amount < 0 ? '- ' : '+ ';
      if(this.type=='RETRAIT'){
        sign = '- ';
      }
      return `${sign}${this.$formatCurrency(Math.abs(this.amount).toFixed(decimalPlaces))}`;
      //return `${sign}${this.symbol}${Math.abs(this.amount).toFixed(decimalPlaces)}`;
    }
  },
};
</script>